<template>
  <div>
    <!-- Page Content -->
    <div class="content">
      <!-- Full Table -->
      <base-block rounded title="Practice Test Child List">
        <br />

        <div class="d-flex justify-content-between mb-2">
          <div class="col-md-2 p-0">
            <b-form-select
              class="form-control"
              v-model="rows"
              @change="
                (pageSelected = 1),
                  (rowsAndFiltersClicked = true),
                  getSubscriptionvideos()
              "
            >
              <b-form-select-option value="10">10</b-form-select-option>
              <b-form-select-option value="25">25</b-form-select-option>
              <b-form-select-option value="50">50</b-form-select-option>
              <b-form-select-option value="100">100</b-form-select-option>
            </b-form-select>
          </div>

          <div class="mb-2">
            <input
              class="form-control"
              type="text"
              v-model="search"
              placeholder="Search..."
              aria-label="Search"
              style="width: 300px"
              @keyup="
                (pageSelected = 1),
                  (rowsAndFiltersClicked = true),
                  getSubscriptionvideos()
              "
            />
          </div>
        </div>

        <b-table-simple
          responsive
          bordered
          striped
          table-class="table-vcenter"
          v-if="subscriptionPracticeTests.length > 0"
        >
          <b-thead>
            <b-tr>
              <b-th class="text-center">S.NO</b-th>
              <b-th class="text-center"> Topic</b-th>
              <b-th class="text-center">Status</b-th>
              <b-th class="text-center">Action</b-th>
            </b-tr>
          </b-thead>

          <b-tbody v-if="subscriptionPracticeTests.length == 0"
            ><b-tr
              ><b-td colspan="4" class="text-center"
                >No records found</b-td
              ></b-tr
            ></b-tbody
          >

          <b-tbody v-else>
            <b-tr
              v-for="(video, index) in subscriptionPracticeTests"
              :key="index"
            >
              <b-td class="text-center">
                {{ (currentPage - 1) * rows + index + 1 }}
              </b-td>
              <b-td class="text-center">
                {{ video.topic.name }}
              </b-td>
              <b-td class="text-center">
                <!-- LIVE START -->
                <!-- <b-button
                  :class="{ 'btn-danger': !video.topic.status }"
                  size="sm"
                  :variant="buttonVariant"
                  @click="
                    toggleStatus(
                      video.college_status.id,
                      index,
                      video.topic.status
                    )
                  "
                >
                  {{ video.topic.status ? "Active" : "Deactive" }}
                </b-button> -->
                <!-- LIVE END -->
                <!-- TEST START -->
                <b-button
                  :class="{ 'btn-danger': !video.college_status.status }"
                  size="sm"
                  :variant="buttonVariant"
                  @click="
                    toggleStatus(
                      video.college_status.id,
                      index,
                      video.college_status.status
                    )
                  "
                >
                  {{ video.college_status.status ? "Active" : "Deactive" }}
                </b-button>
                <!-- TEST END -->
              </b-td>
              <b-td class="text-center">
                <router-link
                  :to="{
                    name: 'College Subscription Pratice Tests Child Topic',
                    params: {
                      subId: video.college_status.college_subscription_id,
                      id: video.id,
                    },
                  }"
                >
                  <b-button size="sm" variant="alt-primary">
                    <i class="fa fa-fw fa-eye"></i>
                  </b-button>
                </router-link>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>

        <!-- pagination -->
        <div class="text-right" v-if="lastPage != 1">
          <b-button-group>
            <b-button
              size="lg"
              variant="outline-primary"
              @click="first()"
              :disabled="
                totalPages.length > 0
                  ? totalPages[0].display
                    ? true
                    : false
                  : false
              "
              ><i class="fas fa-angle-double-left"></i
            ></b-button>
            <b-button
              size="lg"
              variant="outline-primary"
              :disabled="
                totalPages.length > 0
                  ? totalPages[0].display
                    ? true
                    : false
                  : false
              "
              @click="previousPage()"
              ><i class="fas fa-angle-left"></i
            ></b-button>
            <b-button
              :pressed="page.activeStatus == true ? true : false"
              v-show="page.display"
              :id="page.id"
              @click="buttonClick(index)"
              size="lg"
              variant="outline-primary"
              v-for="(page, index) in totalPages"
              :key="index"
              >{{ index + 1 }}</b-button
            >
            <b-button
              size="lg"
              variant="outline-primary"
              @click="nextPage()"
              :disabled="
                totalPages.length > 0
                  ? totalPages[totalPages.length - 1].display
                    ? true
                    : false
                  : false
              "
              ><i class="fas fa-angle-right"></i
            ></b-button>
            <b-button
              size="lg"
              variant="outline-primary"
              @click="last()"
              :disabled="
                totalPages.length > 0
                  ? totalPages[totalPages.length - 1].display
                    ? true
                    : false
                  : false
              "
              ><i class="fas fa-angle-double-right"></i
            ></b-button>
          </b-button-group>
        </div>
        <!-- End Pagination -->

        <br />

        <b-modal
          id="modal-2"
          title="Subscription Video List"
          size="xl"
          ref="modaltwo"
          no-close-on-esc
          no-close-on-backdrop
          hide-footer
        >
          <div class="col-md-12 form-group">
            <b-list-group v-for="(video, index) in videos" :key="index">
              <b-list-group-item class="mb-1">
                <b>Name:</b> {{ video.map_sub_videos.name }} <br />
              </b-list-group-item>
            </b-list-group>
          </div>
          <div class="col-md-12">
            <b-button
              variant="success"
              class="float-right"
              @click="closemodaltwo()"
              >Ok</b-button
            >
          </div>
        </b-modal>
        <!-- Loader -->
        <b-overlay
          :show="loader"
          no-wrap
          blur="2px"
          opacity="0.60"
          class="position-fixed"
        >
          <template #overlay>
            <i class="fa fa-3x fa-cog fa-spin text-primary"></i>
          </template>
        </b-overlay>
      </base-block>
      <!-- END Full Table -->
    </div>
    <!-- END Page Content -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      rowsAndFiltersClicked: false,
      search: "",
      firstDisableStatus: false,
      lastDisableStatus: false,
      rows: 10,
      pageSelected: "",
      currentPage: "",
      lastPage: "",
      totalPages: [],
      loader: false,
      freeStatus: "",
      freeStatusEmpty: false,
      modal2Data: [],
      subscriptionPracticeTests: [],
      selectedVideos: [],
      topic: "",
      topics: [],
      topicEmpty: false,
      parentTopic: "",
      parentTopics: [],
      // tests: [],
      parentTopicEmpty: false,
      videos: [],
      buttonVariant: "success",
    };
  },

  mounted: async function() {
    await this.getSubscriptionvideos();
    this.pagination();
  },

  methods: {
    buttonClick(index) {
      this.totalPages = this.totalPages.map((ele) => {
        if (ele.activeStatus == true) {
          ele.activeStatus = false;
        }
        return ele;
      });
      this.totalPages[index].activeStatus = true;
      let displayedPages = this.totalPages.filter((ele) => ele.display == true);
      if (displayedPages[0] === this.totalPages[index]) {
        if (
          this.totalPages[0].display == false &&
          this.totalPages[1].display == false
        ) {
          this.totalPages[index - 1].display = true;
          this.totalPages[index - 2].display = true;
          this.totalPages[index + 3].display = false;
          this.totalPages[index + 4].display = false;
        }
        if (
          this.totalPages[0].display == false &&
          this.totalPages[1].display == true
        ) {
          this.totalPages[index - 1].display = true;
          this.totalPages[index + 4].display = false;
        }
      }
      if (displayedPages[1] === this.totalPages[index]) {
        if (
          this.totalPages[0].display == false &&
          this.totalPages[1].display == false
        ) {
          this.totalPages[index - 2].display = true;
          this.totalPages[index + 3].display = false;
        }
      }
      if (displayedPages[3] === this.totalPages[index]) {
        if (
          this.totalPages[this.totalPages.length - 1].display == false &&
          this.totalPages[this.totalPages.length - 2].display == false
        ) {
          this.totalPages[index + 2].display = true;
          this.totalPages[index - 3].display = false;
        }
      }
      if (displayedPages[4] === this.totalPages[index]) {
        if (
          this.totalPages[this.totalPages.length - 1].display == false &&
          this.totalPages[this.totalPages.length - 2].display == false
        ) {
          this.totalPages[index + 1].display = true;
          this.totalPages[index + 2].display = true;
          this.totalPages[index - 3].display = false;
          this.totalPages[index - 4].display = false;
        }
        if (
          this.totalPages[this.totalPages.length - 1].display == false &&
          this.totalPages[this.totalPages.length - 2].display == true
        ) {
          this.totalPages[index + 1].display = true;
          this.totalPages[index - 4].display = false;
        }
      }
      this.pageSelected = this.totalPages[index].id.split(" ")[1];
      this.getSubscriptionvideos();
    },
    last() {
      this.totalPages = this.totalPages.map((ele) => {
        if (ele.activeStatus == true) {
          ele.activeStatus = false;
        }
        return ele;
      });
      this.totalPages[this.totalPages.length - 1].activeStatus = true;
      for (var i = 0; i < this.totalPages.length; i++) {
        this.totalPages[i].display = false;
      }
      if (this.lastPage + 1 > 5) {
        for (var j = 0; j < 5; j++) {
          this.totalPages[this.totalPages.length - 1 - j].display = true;
        }
      } else {
        for (var k = 0; k < this.totalPages.length; k++) {
          this.totalPages[this.totalPages.length - 1 - k].display = true;
        }
      }
      this.pageSelected = this.totalPages.length;
      this.getSubscriptionvideos();
    },
    first() {
      this.totalPages = this.totalPages.map((ele) => {
        if (ele.activeStatus == true) {
          ele.activeStatus = false;
        }
        return ele;
      });
      this.totalPages[0].activeStatus = true;
      for (var i = 0; i < this.totalPages.length; i++) {
        this.totalPages[i].display = false;
      }
      for (var j = 0; j < 5; j++) {
        this.totalPages[j].display = true;
      }
      this.pageSelected = 1;
      this.getSubscriptionvideos();
    },
    previousPage() {
      var displayedPages = this.totalPages.filter((ele) => ele.display == true);
      let first = this.totalPages.indexOf(displayedPages[0]);
      let last = this.totalPages.indexOf(
        displayedPages[displayedPages.length - 1]
      );
      this.totalPages[first - 1].display = true;
      this.totalPages[last].display = false;
      this.totalPages = this.totalPages.map((ele, index, totalArray) => {
        if (ele.activeStatus == true) {
          ele.activeStatus = false;
          totalArray[index - 1].activeStatus = true;
        }
        return ele;
      });
      let currentPage = this.totalPages.find((ele) => ele.activeStatus == true);
      this.pageSelected = currentPage.id.split(" ")[1];
      this.getSubscriptionvideos();
    },
    nextPage() {
      var nextArrStatus = false;
      var displayedPages = this.totalPages.filter((ele) => ele.display == true);
      let first = this.totalPages.indexOf(displayedPages[0]);
      let last = this.totalPages.indexOf(
        displayedPages[displayedPages.length - 1]
      );
      this.totalPages[first].display = false;
      this.totalPages[last + 1].display = true;
      this.totalPages = this.totalPages.map((ele) => {
        var data = ele;
        if (data.activeStatus == true) {
          data.activeStatus = false;
          nextArrStatus = true;
        } else if (nextArrStatus) {
          data.activeStatus = true;
          nextArrStatus = false;
        }
        return data;
      });
      let currentPage = this.totalPages.find((ele) => ele.activeStatus == true);
      this.pageSelected = currentPage.id.split(" ")[1];
      this.getSubscriptionvideos();
    },

    pagination() {
      if (this.lastPage + 1 > 5) {
        this.totalPages = [];
        for (var i = 1; i < this.lastPage + 1; i++) {
          this.totalPages.push({
            id: `page ${i}`,
            display: false,
            activeStatus: false,
          });
        }
        this.totalPages = this.totalPages.map((ele, index) => ({
          ...ele,
          display: index < 5,
          activeStatus: index == 0,
        }));
      } else {
        this.totalPages = [];
        for (var j = 1; j < this.lastPage + 1; j++) {
          this.totalPages.push({
            id: `page ${j}`,
            display: false,
            activeStatus: false,
          });
        }
        this.totalPages = this.totalPages.map((ele, index) => ({
          ...ele,
          display: true,
          activeStatus: index == 0,
        }));
      }
    },

    closemodaltwo() {
      this.$refs.modaltwo.hide();
    },
    async getSubscriptionvideos() {
      this.loader = true;
      await axios
        .get(
          `${this.$store.getters.baseUrl}/college_sub/practice-test-child-topics/${this.$route.params.subId}/${this.$route.params.id}?page=${this.pageSelected}&row=${this.rows}&search=${this.search}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.collegeToken}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.subscriptionPracticeTests =
              response.data.child_topic_practice_tests;
            this.loader = false;

            this.lastPage = response.data.pagination.last_page;
            this.currentPage = response.data.pagination.current_page;
            if (this.rowsAndFiltersClicked) {
              this.pagination();
              this.rowsAndFiltersClicked = false;
            }
          } else {
            this.loader = false;
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.loader = false;
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    closeModal() {
      this.$refs.modalone.hide();
      (this.parentTopic = ""),
        (this.topic = ""),
        (this.selectedVideos = []),
        (this.videos = []),
        (this.freeStatus = ""),
        (this.freeStatusEmpty = false);
      (this.parentTopicEmpty = false), (this.topicEmpty = false);
    },
    cancelModal() {
      this.$refs.modalone.hide();
      (this.parentTopic = ""),
        (this.topic = ""),
        (this.freeStatus = ""),
        (this.freeStatusEmpty = false);
      (this.selectedVideos = []),
        (this.videos = []),
        (this.parentTopicEmpty = false),
        (this.topicEmpty = false);
    },

    async getPracticeTestList(id) {
      await axios
        .get(`${this.$store.getters.baseUrl}/college_sub/video-lists/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.collegeToken}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.videos = response.data.subvideos;
            console.log(this.videos);
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async toggleStatus(id, index, status) {
      await axios
        .get(
          `${this.$store.getters.baseUrl}/college_sub/mapped-topic-status/${id}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.collegeToken}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.getSubscriptionvideos();
            this.subscriptionPracticeTests[index].college_status.status =
              status == 1 ? 0 : 1;
            this.$swal({
              text: `${response.data.message}`,
              icon: status ? "error" : "success",
            });
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>
